// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class brandAPI extends MainAPI {
	/**
	 * @return {object} list of brands
	 * @params productType
	 * */
	async getBrands(queryParams) {
		return API.get(`${ENDPOINTS.GET_BRANDS}?${queryString.stringify(queryParams)}`);
	}

	async updateStatusBrand(id,body) {
		return API.put(`${ENDPOINTS.PUT_BRANDS}/${id}/status`, body);
	}

	/**
	 * @return {object} brandDetails
	 * */
	async addBrand(brandDetails) {
		return API.post(`${ENDPOINTS.POST_BRANDS}`, brandDetails);
	}

	/**
	 * @params {object} brandDetails
	 * @params brandId
	 * */
	async updateBrand(brandId, brandDetails) {
		return API.put(`${ENDPOINTS.PUT_BRANDS}/${brandId}`, brandDetails);
	}

	/**
	 * @params brandId
	 * */
	async deleteBrand(brandId) {
		return API.delete(`${ENDPOINTS.DELETE_BRAND}/${brandId}`);
	}
}

export default new brandAPI();
